/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { PropsWithChildren } from 'react';

import { css, jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';

const MenuWrapper = ({ children }: PropsWithChildren<{}>) => (
	<div
		css={[
			menuWrapperStyles,
			fg('blu-6305_tab_item_styling_in_horizontal_navigation') && menuWrapperStylesNew,
		]}
	>
		{children}
	</div>
);

const menuWrapperStyles = css({
	display: 'var(--display-menu)',
});

const menuWrapperStylesNew = css({
	marginRight: token('space.050'),
});

export default MenuWrapper;
